<script lang="ts">
	export let clickable = false;
	export let selected = false;
	export let href: string | undefined = undefined;
	export let express = false;
</script>

{#if href}
	<a
		{href}
		class="rounded-full border px-3 text-3xs font-normal leading-5 md:text-2xs {express && !selected
			? '!border-express bg-express text-white'
			: 'bg-white text-secondary'}"
		class:border-primary={selected}
		class:!text-primary={selected && !express}
	>
		<slot />
	</a>
{:else}
	<button
		class="rounded-full border bg-white px-3 text-3xs font-normal leading-5 text-secondary md:text-2xs"
		class:border-primary={selected}
		class:!text-primary={selected && !express}
		class:pointer-events-none={!clickable}
		class:bg-express={express}
		on:click
	>
		<slot />
	</button>
{/if}
